<template>
    <div style="display: inline">
        <a
                v-if="templateName"
                :href="this.config.baseURL + '/excel/template/'+ this.templateName " target="_blank">
            <el-button size="small" icon="el-icon-upload" type="success">导入模板下载</el-button>
        </a>

        <el-upload
                style="display: inline"
                :action="this.config.baseURL + '/excel/upload'"
                name="file"
                :data="{model:this.model}"
                accept=".xls,.xlsx"
                :show-file-list="false"
                :on-success="success"
                :on-progress="progress"
                :on-error="error"
        >
            <el-button size="small" icon="el-icon-upload" type="success">导入</el-button>
        </el-upload>
    </div>
</template>
<script>
    // Excel 导入组件
    export default {
        name: 'ExcelImport',
        props: {
            model: String, // 数据表名字
            templateName: { // 模板文件名称
                type: String,
                default: null
            }
        },
        data() {
            return {
                loading: null,
            }
        },
        methods: {
            progress() {
                this.loading = this.$loading({
                    lock: true,
                    text: '服务器数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
            success(re) {
                this.loading.close();
                if (re.code === 0) {
                    this.$message.success(re.msg || "操作成功");
                    this.$emit("success");
                } else this.$message.error(re.msg || "出错啦");
            },
            error() {
                console.log('文件上传失败时的钩子')
            }
        }
    }
</script>

<style>

</style>
